import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { signupUser } from "../../../models/signup.model";
import { UserContext } from "../../../services/AppContext/appProvider";
import { useTheme } from "../../../services/ThemeContext";
import { systemErrorAlertText } from "../../../utilities/utils";
// import Swal from "sweetalert2";

type ModalSignupProps = {
  closeModal: () => void;
  modalType: "modal" | "page";
  openLoginModal?: () => void;
};

const ModalSignup: React.FC<ModalSignupProps> = ({
  closeModal,
  modalType,
  openLoginModal
}) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState<string>("");
  const [errorEmail, setErrorEmail] = useState<string>("");
  const referrerToken = localStorage.getItem("referrerToken");
  const { theme } = useTheme();
  const { setCurrentPage } = useContext(UserContext);

  // track current page
  useEffect(() => {
    setCurrentPage("sign_up");
  }, []);

  function validateEmail(): boolean {
    if (!email) {
      setErrorEmail("Email is required");
      return false;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setErrorEmail("Email is invalid");
      return false;
    }

    setErrorEmail("");
    return true;
  }

  async function handleSignup() {
    console.log("login");
    console.log(email);

    if (!validateEmail()) {
      return;
    }
    localStorage.removeItem("profileImage");
    const response = await signupUser(email, referrerToken);

    if (response.rStatus === "success") {
      // on confirmation, close modal
      Swal.fire({
        title: t("Success"),
        html: t(
          "Please check your email for the activation link.\n\nIf you don't see it, remember to look in your spam or junk folder."
        ).replace(/\n/g, "<br>"),
        icon: "success",
        confirmButtonText: t("OK"),
        customClass: {
          popup: "!rounded-lg",
          confirmButton:
            "!bg-secondary !rounded-full !outline-none !border-none !shadow-none"
        }
      }).then(() => {
        setCurrentPage("");
        closeModal();
      });
    } else {
      Swal.fire({
        title: t("Error"),
        html:
          `<strong class="font-extrabold">${response.message}</strong>` +
          systemErrorAlertText(),
        icon: "error",
        confirmButtonText: t("OK"),
        customClass: {
          popup: "!rounded-lg",
          confirmButton:
            "!bg-secondary !rounded-full !outline-none !border-none !shadow-none"
        }
      });
    }
  }

  function showLoginModal() {
    setCurrentPage("");
    closeModal();
    if (openLoginModal) {
      openLoginModal();
    }
  }

  return (
    <>
      {modalType === "page" && <div className="h-full xl:h-[62vh]"></div>}
      <div
        className={`modal modal-open ${modalType === "page" && "!bg-transparent"}`}
        dir="auto"
      >
        <div className={`modal-box max-w-md rounded-lg`} dir="auto">
          <div className="modal-action mt-0">
            <label
              className="btn btn-circle btn-sm absolute right-2 top-2 text-secondary"
              onClick={() => {
                setCurrentPage("");
                closeModal();
              }}
            >
              ✕
            </label>
          </div>
          <h3
            className="mb-3 text-center text-2xl font-bold text-secondary"
            dir="auto"
          >
            {t("Sign Up")}
          </h3>
          <p className="pt-4">
            <strong>
              {t(
                "Enter your email address to receive a link to create an account"
              )}
            </strong>
          </p>
          <div className="form-control">
            <label className="label">
              <span
                className={`label-text ${theme === "dark" ? "text-white" : "text-neutral"}`}
              >
                {t("Email Address")}
              </span>
            </label>
            <input
              type="email"
              placeholder={t("Email Address")}
              className="input input-bordered"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errorEmail && (
              <label className="label text-error">{errorEmail}</label>
            )}
          </div>
          <div className="modal-action">
            <button
              type="submit"
              className="btn btn-secondary btn-sm m-auto rounded-lg border-none text-base-100 disabled:bg-secondary disabled:text-base-100 disabled:opacity-50"
              onClick={handleSignup}
              disabled={!email}
            >
              {t("Sign Up")}
            </button>
          </div>
          {openLoginModal && (
            <div className="mt-3">
              <p className="text-center">
                {t("Already have an account?")}{" "}
                <button
                  className="text-secondary underline"
                  onClick={showLoginModal}
                >
                  {t("Log In")}
                </button>
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ModalSignup;
